import defaultTheme from './default';
import setAlias from './alias';

const getTheme = (theme = defaultTheme) => () => setAlias(theme);

export const getDefaultTheme = getTheme(defaultTheme);
